<div ui-view>
  <div class="row content__grid">
    <div class="col-lg-12 col-md-12 col-sm-12 col-12">
      <div class="page-title-box">
        <div class="row align-items-center">
          <div class="col-sm-6 col-md-6 col-sm-6 col-12">
            <h4 class="page-title content__title">
              Stock de productos
              <span class="badge badge-info m-l-5 f-s-11">Bienes, con el control de stock activo</span>
            </h4>
          </div>
        </div>
      </div>
    </div>
    <div class="col-lg-12 col-lg-12 col-md-12 col-sm-12 col-12">
      <div class="row m-b-15">
        <div class="col-lg-7 col-md-7 col-sm-6 col-12 content__subhead__boxBtns">
          <button type="button" class="btn btn-light btn-sm" title="Actualizar" (click)="refresh()">
            <i class="fas fa-undo"></i></button>
          <div class="content__subhead__inputGrid">
            <div class="input-group">
              <span class="input-group-prepend"><span
                  class="input-group-text content__subhead__inputGrid__title">Almacén</span></span>
              <select class="form-control content__subhead__inputGrid__input" id="warehousesSelected"
                [(ngModel)]="warehouseSelected" (change)="changeWarehouseSelected()">
                <option *ngFor="let item of warehouses" [value]="item.id">{{ item.description }}</option>
              </select>
            </div>
          </div>
          <a type="button" class="btn btn-sm btn-light" title="Exportar" 
          target="_blank" href="/{{branchofficeSlug}}/api/report/warehouse/stockgeneral?&format=1&warehouse={{warehouseSelected}}">
            Exportar <i class="fas fa-file-export"></i>
          </a>
        </div>
        <div class="col-lg-5 col-md-5 col-sm-6 col-12">
          <component-search (searchEvent)="search($event)"></component-search>
        </div>
      </div>
      <div class="card m-b-30">
        <div class="content__boxTble">
          <div class="table-responsive">
            <table class="table mb-0 table-sm">
              <thead class="thead-default">
                <tr>
                  <th>Producto</th>
                  <th>Marca</th>
                  <th>Línea</th>
                  <th>Medida</th>
                  <th class="text-center">Stock mínimo</th>
                  <th>Equivalencias</th>
                  <th>Lote fecha vcto.</th>
                </tr>
              </thead>
              <tbody>
                <ng-container *ngIf="items.length == 0">
                  <td colspan="2"><span>No se encontraron registros</span></td>
                </ng-container>
                <ng-container *ngIf="items.length > 0">
                  <tr
                    *ngFor="let item of items | paginate: { itemsPerPage: dataPagination.pageSize, currentPage: dataPagination.currentPage, totalItems:dataPagination.totalItems }; let i = index">
                    <td>
                      <p class="m-b-2">{{item.description}}</p>
                      <p class="m-b-0 f-s-11">{{item.code}}</p>
                    </td>
                    <td>
                      <ng-container *ngIf="item.brand_id != null">
                        {{item.brand.description}}
                      </ng-container>
                    </td>
                    <td>
                      <ng-container *ngIf="item.line_id != null">
                        {{item.line.description}}
                      </ng-container>
                    </td>
                    <td>
                      <span>{{item.productstock[0].unidad_plural}}</span>
                    </td>
                    <td class="text-center">
                      <ng-container *ngFor="let stock of item.productstock">
                        <div>
                          <span class="bold">{{stock.stock}}</span>
                          <span class="m-l-5">{{stock.unitprefix}}</span>
                        </div>
                      </ng-container>
                    </td>
                    <td>
                      <ng-container *ngFor="let unit of item.unitsmeasure">
                        <div class="f-s-11">
                          <span>{{unit.description}} ({{unit.equivalence}}) =>
                            {{(item.productstock[0].stock / unit.equivalence).toFixed(2)}} </span>
                        </div>
                      </ng-container>
                    </td>
                    <td>
                      <ng-container *ngIf="item.productbatch != null">
                        <div class="f-s-11" *ngFor="let batch of item.productbatch">
                          <span>{{batch.date_expiration}} => {{batch.quantity}}</span>
                        </div>
                      </ng-container>
                    </td>
                  </tr>
                </ng-container>
              </tbody>
            </table>
          </div>
        </div>
        <div class="col-md-12 ">
          <div class="row content_pagination">
            <div class="col-lg-4">
              <p class="pagination__label">Total <span class="bold">{{dataPagination.totalItems}}</span> registros.</p>
            </div>
            <div class="text-right col-lg-8">
              <ng-container *ngIf="items.length > 0">
                <app-pagination (paginateEvent)="handlePageChange($event)"></app-pagination>
              </ng-container>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>

